import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StatusColorIndicator } from '@adsk/bim360-matrix-react-status-color-indicator';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { Colors } from '@adsk/bim360-matrix-react-helpers/es/consts';

import './_LinkedEntitiesCellBlock.scss';

const LinkedEntitiesCellBlock = ({
  className,
  entityTypeName,
  userFriendlyId,
  deeplinkUrl,
  title,
  statusColor
}) => {
  const classes = classNames('LinkedEntityCellBlock', className);
  const onClick = deeplinkUrl
    ? e => {
      e.preventDefault();
      e.stopPropagation();
      window.open(deeplinkUrl);
    }
    : undefined;
  return (
    <div className={classes} onClick={onClick}>
      <StatusColorIndicator
        statusColor={statusColor}
        classNames="LinkedEntityCellBlock__indicator"
      />
      <div className="LinkedEntityCellBlock__text-type">{entityTypeName}</div>
      {userFriendlyId && (
        <span className="LinkedEntityCellBlock__identifier">{userFriendlyId}</span>
      )}
      <div className="LinkedEntityCellBlock__text-item">{title}</div>
    </div>
  );
};

LinkedEntitiesCellBlock.propTypes = {
  /**
   * Class to add to the component
   */
  className: PropTypes.string,
  /**
   * Entity type name - a user facing text describing entity type.
   */
  entityTypeName: PropTypes.string.isRequired,
  /**
   * The title of the entity.
   */
  title: PropTypes.string.isRequired,
  /**
   * A user friendly ID if exists.
   */
  userFriendlyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * A deeplink for showing the entity in its original feature module.
   */
  deeplinkUrl: PropTypes.string,
  /**
   * The status color of the entity. On of Colors values.
   */
  statusColor: PropTypes.oneOf(objectValues(Colors))
};
export default LinkedEntitiesCellBlock;
